import React from 'react';

export default function MovingCompanies() {
  return (
    <main style={{ padding: 32 }}>
      <h1 style={{ margin: '0 0 8px', fontSize: 32, fontWeight: 900 }}>Moving companies</h1>
      <p style={{ fontSize: 16 }}>Browse and compare trusted moving companies in your area.</p>
    </main>
  );
}
